/**
 * Created by rak on 7/26/2018.
 */
'use strict';

angular.module('dashboard.tachoEventDetail', ['adf.provider'])
  .config(function (dashboardProvider) {
    dashboardProvider
      .widget('tachoEventDetailWidget', {
        resolve: {
          title: function () {
            return 'dashBoard.fleetManagement.tachoEventDetail.tachoEventDetailTitle';
          },
          description: function () {
            return 'dashBoard.fleetManagement.tachoEventDetail.description';
          }
        },
        controller: 'tachoEventDetailCtrl',
        templateUrl: 'components/dashboard/tachoEventDetails/tachoEventDetailWidget.tpl.html',
        isSingleInstance: true,
        edit: {
          templateUrl: 'components/dashboard/tachoEventDetails/tachoEventDetailWidgetEdit.tpl.html',
          reload: false,
          controller: 'tachoEventDetailEditCtrl'
        }
      });

  }).service('tachoEventDetailWidgetService', function (crudService, $filter) {

    var lastSelectedHistoryRow = null;
    var cachedGrpahicsDataList = null;
    this.getTachoeventGraphicsList = function (dateFrom, driverId, isDataRefresh) {
      var requestParam = {
        dataRefresh: isDataRefresh,
        timeTo: $filter('date')(dateFrom, 'yyyy/MM/dd/') + '23:59:59',
        timeFrom: $filter('date')(dateFrom, 'yyyy/MM/dd/') + '00:00:00',
        reportOptions: { driverID: [driverId] }
      };
      var param = {
        'filter': JSON.stringify(requestParam)
      };
      return crudService.customGET('driverdashboard/tachoeventgraphic', '', param);
    };


    this.getTachoStampingTimesList = function (dateFrom, driverId, isDataRefresh) {
      var requestParam = {
        dataRefresh: isDataRefresh,
        timeTo: $filter('date')(dateFrom, 'yyyy/MM/dd/') + '23:59:59',
        timeFrom: $filter('date')(dateFrom, 'yyyy/MM/dd/') + '00:00:00',
        reportOptions: { driverID: [driverId] },
        reportOption: driverId
      };
      var param = {
        'filter': JSON.stringify(requestParam)
      };
      return crudService.customGET('driverdashboard/costcenterevents', '', param);
    };



    this.getLastSelectedHistoryRow = function () {
      return lastSelectedHistoryRow;
    };
    this.setLastSelectedHistoryRow = function (rodData) {
      lastSelectedHistoryRow = rodData;
    };

    this.setGrpahicsCachedList = function (dataList) {

      cachedGrpahicsDataList = dataList;
    };

    this.getGrpahicsCachedList = function () {

      return cachedGrpahicsDataList;
    };


  }).controller('tachoEventDetailCtrl', function ($scope, config, tachoEventDetailWidgetService, commonTrackService, vehicleListWidgetService, errorHandlingService, $rootScope, $timeout, stateManagerService, AuthenticationService) {
    var isWidgetIsinfullScreen = $('body.modal-open').length > 0 ? true : false;

    $scope.isNotAuthorized = false;
    $scope.isDataNotAvailable = false;
    $scope.isWidgetPreInitFinished = false; // Pre ini animation automatically removed if anoy one of above two flags set to true
    $scope.isWidgetPostInitFinished = false;

    $scope.driverEventDetailTab = 0;
    $scope.overviewGridPrefix = commonTrackService.getOverviewGridPrefix();

    var tachoGraphicGridListSource =
    {
      datatype: 'array',
      datafields: [],
      localdata: [],
      sort: null
    };




    var rowSize = vehicleListWidgetService.getRowSize();
    $scope.customGridProperties = {
      tachoGraphicDetail: {
        height: config.noOfGridRows ? rowSize[config.noOfGridRows] + 15 : 455,
        pageable: false,
        columns: []
      },
      tachoStampingEventDetail: {
        height: config.noOfGridRows ? rowSize[config.noOfGridRows] + 15 : 455,
        pageable: false,
        columns: []
      }
    };
    $scope.dataLoadingFinished = false;
    $scope.dataStampingLoadingFinished = false;
    $scope.lastEventTime = 0;
    $scope.gridDataList = [];

    $scope.widgetData = {};


    var tachoStampingEventListSource =
    {
      datatype: 'array',
      datafields: [],
      localdata: [],
      sort: null
    };

    var loadtachoStampingTimesGrid = function (date, driverID, isForceRefresh) {
      $scope.isStampingNotAuth = false;
      tachoEventDetailWidgetService.getTachoStampingTimesList(date, driverID, isForceRefresh).then(function (tachoStampingList) {
        if (!$scope.tachoStampingEventListdataAdapter) {
          $scope.customGridProperties.tachoStampingEventDetail.columns = commonTrackService.getColumnProperties(tachoStampingList.gridSettings.overviewListGrids[0].columnProperties, tachoStampingList.columnTranslation, { moduleName: 'tachoStampingTimesGrid' });
          $scope.tachoStampingTimesGridSettings = commonTrackService.getGridSettings('tachoStampingTimesGrid', $scope.customGridProperties.tachoStampingEventDetail, null);
          tachoStampingEventListSource.localdata = tachoStampingList.dataList;
          $scope.tachoStampingEventListdataAdapter = new $.jqx.dataAdapter(tachoStampingEventListSource);
          $scope.tachoStampingTimesGridSettings.source = $scope.tachoStampingEventListdataAdapter;
        } else {
          tachoStampingEventListSource.localdata = tachoStampingList.dataList;
          commonTrackService.updateBoundData($scope.overviewGridPrefix + 'tachoStampingTimesGridList');
        }
      }, function (error) {
        // do something with error response
        console.log(error);
        $scope.isStampingNotAuth = true;
      }).finally(function () {
        if (!$scope.dataStampingLoadingFinished) {
          $scope.dataStampingLoadingFinished = true;
        }
      });
    };


    $scope.tachoStampingTimeRowSelectHandler = function(event){
      if (event.type === 'rowselect' && event.args.row) {
        var eventRow = event.args.row;
        commonTrackService.iframePostMessage('jsmDrawPushpinAtPoint('+ eventRow.latitude + ',' + eventRow.longitude + ',2)', 'vehicleMap');
      }
    };

    $scope.stampingEventsTabSelect = function () {
      var rowData = tachoEventDetailWidgetService.getLastSelectedHistoryRow();

      // this is based since there is a difference between the selected Row and what the grid can display.
      // ie. if you select a row then change the date, that row is still selected even if it is no longer shown.
      // this links back to how widgets should interact with one another. See BUG 89998.
      if (rowData && rowData.date === $scope.widgetData.date) {
        loadStampingEventDetails(rowData);
      }
      else {
        loadStampingEventDetails($scope.widgetData);
      }
    };


    var loadStampingEventDetails = function (rowData) {
      var driverID = '';
      if (rowData) {

        if (rowData.selectedRow) {
          driverID = rowData.selectedRow.driverid;
        }else{
          driverID = rowData.driverid;
        }
        loadtachoStampingTimesGrid(rowData.date, driverID, !$scope.tachoStampingTimesGridSettings || !$scope.tachoStampingEventListdataAdapter ? true : false);
      } else {
        loadtachoStampingTimesGrid(new Date(), driverID, true);
      }
    };

    var setWidgetData = function(date, selectedRow){
      if(!$scope.widgetData){
        $scope.widgetData = {};
      }

      $scope.widgetData.date = date;
      $scope.widgetData.selectedRow = selectedRow;

      if($scope. driverEventDetailTab === 2){
        loadtachoStampingTimesGrid(date, selectedRow.driverid, true);
      }
    };

    var loadTachoGraphicsGrid = function (date, driverID, isForceRefresh) {
      $scope.isDataNotAvailable = false;
      $scope.isNotAuthorized = false;
      tachoGraphicGridListSource.localdata = [];
      tachoEventDetailWidgetService.getTachoeventGraphicsList(date, driverID, isForceRefresh).then(function (tachoGraphicsList) {
        _handleGrphicsdataList(tachoGraphicsList, false);


      }, function (response) {
        if (errorHandlingService.errorForNoAuthorized(response)) {
          $rootScope.$broadcast('rest-error-event', response);
          $scope.isNotAuthorized = true;
        }
      }).finally(function () {
        $rootScope.$broadcast('tacho_event_history_init_graphic', {
          dataList: $scope.gridDataList,
          eventType: 'tacho_event_history_table_row_select'
        });
        if (!$scope.dataLoadingFinished) {
          $scope.dataLoadingFinished = true;
        }
        $scope.createTachoGraphicsGrid = true;



      });
    };

    function _handleGrphicsdataList(tachoGraphicsList, isFromCahe) {

      if (tachoGraphicsList.dataList) {
        $scope.gridDataList = $.extend(true, [], tachoGraphicsList.dataList);
        tachoEventDetailWidgetService.setGrpahicsCachedList(tachoGraphicsList);
      }

      if (!$scope.tachoGraphicsDetailsListdataAdapter) {
        $scope.customGridProperties.tachoGraphicDetail.columns = commonTrackService.getColumnProperties(tachoGraphicsList.gridSettings.overviewListGrids[0].columnProperties, tachoGraphicsList.columnTranslation, { moduleName: 'tachoGraphicsDetailsGrid' });
        $scope.tachoGraphicsDetailsGridSettings = commonTrackService.getGridSettings('tachoGraphicsDetailsGrid', $scope.customGridProperties.tachoGraphicDetail, null);
        tachoGraphicGridListSource.localdata = tachoGraphicsList.dataList;
        $scope.tachoGraphicsDetailsListdataAdapter = new $.jqx.dataAdapter(tachoGraphicGridListSource);
        $scope.tachoGraphicsDetailsGridSettings.source = $scope.tachoGraphicsDetailsListdataAdapter;

      } else {
        tachoGraphicGridListSource.localdata = tachoGraphicsList.dataList;
        commonTrackService.updateBoundData($scope.overviewGridPrefix + 'tachoGraphicsDetailsGridList');
      }
      $scope.isDataNotAvailable = tachoGraphicsList.dataList.length === 0 ? true : false;
      if (isFromCahe) {
        $scope.dataLoadingFinished = true;
        $scope.createTachoGraphicsGrid = true;
        $rootScope.$broadcast('tacho_event_history_init_graphic', {
          dataList: $scope.gridDataList,
          eventType: 'tacho_event_history_table_row_select'
        });
      }

    }
    $scope.initTachoDetailsGraphic = function () {

    };
    $timeout(function () {
      $rootScope.$broadcast('reqDataUpdate');
    }, 0);

    var dataStateUpdateListener = $scope.$on('dataStateUpdate', function (event, data) {
      if ($scope.isWidgetPostInitFinished) {
        var set = getSetData(data.widget);
        _handleDataUpdate(data.dashboardName, data.activeTab, set['tab_' + data.activeTab + '_selectedRow'].value, data.widget);
      } else {
        //console.log('Ignoring dataState update from widget: ' + data.widget);
      }

    });

    // Modification for the Loading Imporvement
    var getSetData = function (widget) {
      var loginID = AuthenticationService.GetLoginID();
      widget = loginID.Account+'_'+loginID.username +'_'+widget;
      var stateData = stateManagerService.getStateData();
      var set = stateData && stateData[widget] ? stateData[widget] : {};
      return set;
    };


    var loadDependentDataFromServer = function (data) {
      loadTachoGraphicsGrid(data.selectedRow.date, data.selectedRow.driverid, true);
    };

    var maxGetInitialDataRetries = 30;
    var currentParentRowResEvent = $scope.$on('resDataUpdate', function (event, data) {
      if (maxGetInitialDataRetries < 0 || $scope.isWidgetPostInitFinished) {
        currentParentRowResEvent();
        return;
      }
      // console.info(' Tacho Event Details Widget Requesting Parent for Data ..');

      --maxGetInitialDataRetries;
      var set = getSetData(data.widget);
      var selectedParentTabRowValues = set['tab_' + data.activeTab + '_selectedRow'];


      // parents First tab must always retrun a  valid selected row
      if ((data.activeTab === 0 && !_.isEmpty(selectedParentTabRowValues) && !_.isEmpty(selectedParentTabRowValues.value)) || (data.activeTab > 0 && !_.isEmpty(selectedParentTabRowValues))) {
        $scope.isWidgetPreInitFinished = true;
        $scope.isWidgetPostInitFinished = true;
        _handleDataUpdate(data.dashboardName, data.activeTab, selectedParentTabRowValues.value, data.widget);

      } else {
        // Repeatedly try to get the data from parent .
        if (maxGetInitialDataRetries > 0) {
          $timeout(function () {
            if (!$scope.isWidgetPostInitFinished) {
              $rootScope.$broadcast('reqDataUpdate');
            }
          }, 100);
        } else {
          console.warn('Max Retries exceeded to get the current Parent data for Tacho Event Details Widget..');
          $scope.isWidgetPreInitFinished = true;
          $scope.isWidgetPostInitFinished = true;
          $scope.isDataNotAvailable = true;
          currentParentRowResEvent();
        }
      }

    });

    function _handleDataUpdate(dashboardName, tabNumber, rowData, widgetName) {
      var set, rowDetails;

      switch (dashboardName) {
        case 'dashboard.driverWrkHrsDashboard': // contains only tab 0
          switch (tabNumber) {
            case 0:
              if (!_.isEmpty(rowData)) {
                loadTachoGraphicsGrid(rowData.driverworkingdate, rowData.driverid, true);
                setWidgetData(rowData.driverworkingdate,  rowData);
              } else {
                $scope.isDataNotAvailable = true;
              }
              break;
          }
          break;
        case 'dashboard.tachohistory': // contains only tab 0
          switch (tabNumber) {
            case 0:
              if (!_.isEmpty(rowData)) {

                set = getSetData(widgetName);
                loadTachoGraphicsGrid(set.date.value, rowData.driverid, true);
                setWidgetData(set.date.value,  rowData);
              } else {
                $scope.isDataNotAvailable = true;
              }

              break;

          }
          break;
        case 'dashboard.fmsDashboard':
        case 'dashboard.vehicleList':
          switch (tabNumber) {
            case 0: // first tab use device id to  load data from server
              set = getSetData(widgetName);
              rowData = set['tab_' + 0 + '_selectedRow'];
              if (!_.isEmpty(rowData.value)) {
                rowDetails = Object.assign({}, rowData.value);
                rowDetails.date = rowDetails.date.indexOf('T') > -1 ? moment(rowDetails.date).toDate() : moment(rowDetails.date, 'DD/MM/YYYY').toDate();
                setWidgetData(rowData.date,  rowDetails);
                loadDependentDataFromServer({ selectedRow: rowDetails });

              } else {
                $scope.isDataNotAvailable = true;
              }
              break;
            case 1: // use the Service stored Data
            case 2:
            case 3:
              if (isWidgetIsinfullScreen) {
                var cahchedData = tachoEventDetailWidgetService.getGrpahicsCachedList();
                if (!_.isEmpty(cahchedData)) {
                  _handleGrphicsdataList(cahchedData, true);
                } else {
                  set = getSetData(widgetName);
                  rowData = set['tab_' + 0 + '_selectedRow'];
                  if (!_.isEmpty(rowData.value)) {
                    rowDetails = Object.assign({}, rowData.value);
                    rowDetails.date = rowDetails.date.indexOf('T') > -1 ? moment(rowDetails.date).toDate() : moment(rowDetails.date, 'DD/MM/YYYY').toDate();
                    setWidgetData(rowDetails.date,  rowDetails);
                    loadDependentDataFromServer({ selectedRow: rowDetails });

                  } else {
                    $scope.isDataNotAvailable = true;
                  }
                }
              }

              break;
          }
          break;

      }
    }
    $scope.$on('$destroy', function () {
      currentParentRowResEvent();
      dataStateUpdateListener();
    });

  }).controller('tachoEventDetailEditCtrl', function ($scope, config, $translate, widgetSettingsCreatorService) {

    $scope.noOfGridRows = config.noOfGridRows;
    var source = [
      '5', '10', '15', '25', '50', '75', '100'
    ];

    // init DropDownList's settings object.
    $scope.noOfRowsettings =
    {
      placeHolder: $translate.instant('dashBoard.fleetManagement.vehicleList.noOfGridRows'),
      width: 200, height: 25,
      autoDropDownHeight: true,
      theme: widgetSettingsCreatorService.fetchWidgetStyleSettings().theme, // 'material', // theme: 'bootstrap',
      source: source
    };

    $scope.noOfGridOnChange = function (event) {
      config.noOfGridRows = event.args.item.value;
    };
  });




// WEBPACK FOOTER //
// ./.tmp/components/dashboard/tachoEventDetails/tachoEventDetailWidget.js